var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.035,
    height: 30.5,
    viewBox: "0 0 97.035 30.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4664ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff466c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Medicine",
    transform: "translate(-982.014 -700.463)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12409",
    "data-name": "Group 12409",
    transform: "translate(982.514 700.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M33.624,6.638h1.83c.088.749.866,1.238,1.87,1.238s1.705-.485,1.705-1.15c0-.588-.437-.917-1.529-1.161L36.32,5.3c-1.669-.355-2.494-1.2-2.494-2.528C33.826,1.108,35.274,0,37.291,0c2.111,0,3.437,1.088,3.467,2.727H38.982c-.064-.768-.737-1.23-1.685-1.23s-1.561.443-1.561,1.115c0,.562.438.875,1.481,1.111l1.1.233c1.811.39,2.6,1.169,2.6,2.547,0,1.761-1.424,2.873-3.674,2.873C35.071,9.376,33.682,8.337,33.624,6.638ZM0,4.687C0,1.765,1.665,0,4.289,0A3.734,3.734,0,0,1,8.268,3.411H6.424A2.1,2.1,0,0,0,4.289,1.57c-1.434,0-2.357,1.2-2.357,3.109,0,1.933.913,3.127,2.361,3.127A2.049,2.049,0,0,0,6.431,6.073H8.271a3.674,3.674,0,0,1-3.982,3.3C1.648,9.376,0,7.612,0,4.687Zm49.279,3.6a1.011,1.011,0,1,1,1.013,1.008A1,1,0,0,1,49.279,8.284Zm-4.872.936V5.832L41.255.156h2.066l2.027,3.869H45.4L47.428.156h2.03L46.3,5.832V9.22Zm-16.013,0v-7.5H25.779V.156h7.138V1.723H30.295v7.5Zm-5.288,0L21.413,5.9h-1.52V9.22H18V.156h3.708c2.09,0,3.281,1.1,3.281,2.892a2.664,2.664,0,0,1-1.645,2.574l1.908,3.6Zm-3.213-4.69h1.635A1.358,1.358,0,0,0,23.04,3.082a1.39,1.39,0,0,0-1.53-1.443H19.894ZM15.063,9.22l-.692-2.2H11.187l-.692,2.2H8.551L11.7.156h2.227L17.075,9.22ZM11.594,5.6h2.369L12.8,1.891h-.045Z",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12410",
    "data-name": "Group 12410",
    transform: "translate(983.549 715.396)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21537",
    "data-name": "Path 21537",
    d: "M997.138,732.016V720.407h-.075l-4.951,11.505h-1.636l-4.951-11.505h-.075v11.609h-1.807V716.951h2.249l5.36,12.571h.086l5.359-12.571h2.25v15.065Z",
    transform: "translate(-983.641 -716.7)",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21538",
    "data-name": "Path 21538",
    d: "M1013.209,732.016h-9.623V716.951h9.623v1.691h-7.686v4.835h7.287v1.67h-7.287v5.179h7.686Z",
    transform: "translate(-985.267 -716.7)",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21539",
    "data-name": "Path 21539",
    d: "M1022.06,716.951c4.607,0,7.33,2.788,7.33,7.527s-2.712,7.539-7.33,7.539h-5.22V716.951Zm-3.283,13.375h3.154c3.52,0,5.479-2.089,5.479-5.826,0-3.77-1.948-5.858-5.479-5.858h-3.154Z",
    transform: "translate(-986.348 -716.7)",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21540",
    "data-name": "Path 21540",
    d: "M1033.117,732.016V716.951h1.938v15.065Z",
    transform: "translate(-987.676 -716.7)",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21541",
    "data-name": "Path 21541",
    d: "M1037.852,724.455c0-4.729,2.744-7.777,7-7.777,3.379,0,5.952,1.995,6.447,5h-1.959a4.424,4.424,0,0,0-4.488-3.268c-3.036,0-5,2.381-5,6.044,0,3.7,1.948,6.056,5.015,6.056,2.282,0,3.918-1.065,4.478-2.9h1.959c-.71,2.976-3.013,4.635-6.447,4.635C1040.564,732.245,1037.852,729.228,1037.852,724.455Z",
    transform: "translate(-988.062 -716.678)",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21542",
    "data-name": "Path 21542",
    d: "M1054.973,732.016V716.951h1.937v15.065Z",
    transform: "translate(-989.458 -716.7)",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21543",
    "data-name": "Path 21543",
    d: "M1060.363,732.016V716.951h1.884l8.5,11.829h.1V716.951h1.916v15.065h-1.883l-8.5-11.786h-.1v11.786Z",
    transform: "translate(-989.897 -716.7)",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21544",
    "data-name": "Path 21544",
    d: "M1086.766,732.016h-9.622V716.951h9.622v1.691h-7.685v4.835h7.287v1.67h-7.287v5.179h7.685Z",
    transform: "translate(-991.266 -716.7)",
    fill: "#212121"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.c4e6b82fc5d8716c1647a2cef71b3929.svg";
export { ForwardRef as ReactComponent };